
import { FC, useContext } from "react";

import { SpeciesContext } from "../../contexts/data/SpeciesContext";
import SpeciesContentPage from "../SpeciesContentPage";


const SpeciesHomePage: FC = () => {
    const { species: { key } } = useContext(SpeciesContext);

    return (
        <SpeciesContentPage page={`${key}_homepage`} />
    );
}

export default SpeciesHomePage;